import * as angular from "angular";
import {IIntervalService, IWindowService} from "angular";
import {OmsOrdersAlertsService} from "../../oms/services/oms-orders-alerts.service";

export class OmsOrdersNotificationsService{
  omsOrdersRef: any;
  omsOrdersNotificationInterval: any;

  private ordersQueue: any[];

  constructor(private $window: IWindowService, private $omsOrder, private $interval: IIntervalService,
              private omsOrdersAlertsService: OmsOrdersAlertsService, private $state) {
    this.ordersQueue = [];
  }

  initOrdersChannelNotifications() {
    this.omsOrdersRef = this.$omsOrder();

    this.omsOrdersRef.$subscribeToChannelEvents((orders, action) => {
      if (action === 'created') {

        if (!this.ordersQueue.length) {
          this._initNotificationInterval();
        }

        this.ordersQueue = this.ordersQueue.concat(orders)
      }
    });

  }

  destroyOmsOrdersNotifications() {
    if (this.omsOrdersRef) {
      this.omsOrdersRef.$destroyChannel();
      this.omsOrdersRef = undefined;
    }

    this._destroyNotificationInterval();
  }

  private _initNotificationInterval() {
    this.omsOrdersNotificationInterval = this.$interval(() => {
      if (this.ordersQueue.length) {
        const order = this.ordersQueue[0];
        this.omsOrdersAlertsService.addedInfo(order, true)
          .then((res) => {
            if (res) {
              const url = this.$state.href('order.info', {id: order.id});
              this.$window.open(url, '_blank');
            }
          });
        this.ordersQueue.splice(0, 1);

        if (!this.ordersQueue.length) {
          this._destroyNotificationInterval();
        }
      } else {
        this._destroyNotificationInterval();
      }
    }, 5000);
  }

  private _destroyNotificationInterval() {
    if (this.omsOrdersNotificationInterval) {
      this.$interval.cancel(this.omsOrdersNotificationInterval);
      this.omsOrdersNotificationInterval = undefined;
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .service('omsOrdersNotificationsService', OmsOrdersNotificationsService);
